/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */

import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';

import { REQUEST_NEW_IMAGE_REQUEST, success, failure } from './action';

const events = (action$, state$, { AjaxRequest }) =>
  action$
    .ofType(REQUEST_NEW_IMAGE_REQUEST)
    .map(({ payload }) => payload)
    .mergeMap((data) =>
      AjaxRequest.open(
        'post',
        '/admin/contractcustom/requestnewimage',
        data,
      )('tudo')
        .flatMap(({ response }) => Observable.of(success(response.resource)))
        .catch((err) => Observable.of(failure(err))),
    );

export default combineEpics(events);
